import { readJsonStorage, writeJsonStorage } from "./localStorageState";
import { RECENTLY_VIEWED_STORAGE_KEY } from "./storageKeys";

export const RECENTLY_VIEWED_LIMIT = 8;

export function normalizeRecentProduct(product) {
  if (!product || typeof product !== "object") return null;
  const id = product.productId ?? product.productID ?? product.id;
  if (id == null) return null;
  return {
    id,
    productId: id,
    name: product.name ?? product.productName ?? "Product",
    productName: product.productName ?? product.name ?? "Product",
    image: product.image ?? product.frontImg ?? product.images?.[0]?.url ?? product.images?.[0] ?? "",
    frontImg: product.frontImg ?? product.image ?? product.images?.[0]?.url ?? product.images?.[0] ?? "",
    price: product.price ?? product.productPrice ?? product.rentalPrice ?? null,
    viewedAt: product.viewedAt || new Date().toISOString(),
  };
}

export function dedupeRecentProducts(items, limit = RECENTLY_VIEWED_LIMIT) {
  const seen = new Set();
  const result = [];
  for (const item of Array.isArray(items) ? items : []) {
    const normalized = normalizeRecentProduct(item);
    const id = normalized?.id == null ? null : String(normalized.id);
    if (!id || seen.has(id)) continue;
    seen.add(id);
    result.push(normalized);
    if (result.length >= limit) break;
  }
  return result;
}

export function getRecentlyViewedProducts() {
  const saved = readJsonStorage(RECENTLY_VIEWED_STORAGE_KEY, []);
  return dedupeRecentProducts(saved);
}

export function rememberRecentlyViewedProduct(product) {
  const normalized = normalizeRecentProduct(product);
  if (!normalized) return [];
  const existing = getRecentlyViewedProducts().filter((item) => String(item.id) !== String(normalized.id));
  const next = dedupeRecentProducts([normalized, ...existing]);
  writeJsonStorage(RECENTLY_VIEWED_STORAGE_KEY, next);
  return next;
}
